<template>
  <custom-dialog width="75%" :title="model.title" :visible="visible" v-on="$listeners">
    <div style="padding: 0 24px">
      <div class="search-hd" style="text-align: right; margin-bottom: 24px">
        <search-input style="margin-right: 12px" width="200px" v-model="formSearch.company" :placeholder="$t('bind_location_dialog.gong_si_ming_cheng')" @fetch="onPageChange({ page: 1 })"></search-input>
        <search-input width="300px" v-model="formSearch.search" :placeholder="$t('Common.com_location_name')" @fetch="onPageChange({ page: 1 })"></search-input>
      </div>
      <div class="table-bd">
        <custom-table
          stripe
          height="500px"
          type="checkbox"
          tableCode="organ_select_location"
          v-model="tableSelect"
          @column="setColumn"
          :data="tableList"
          @filter="filterChange"
          @sort="sortChange"
        ></custom-table>
      </div>
      <div class="table-page">
        <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="warning" @click="bindDevice">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  props: {
    organ: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tableList: [],
      totalRows: 0,
      tableSelect: [],
      formSearch: {
        search: '',
        company: '',
        bizId: '',
        bizType: '',
        parentId: '',
        isAss: 0,
        pageSize: 50,
        pageNum: 1,
      },
    };
  },
  mounted() {
    this.getLocationList();
  },
  methods: {
    // 获取设备列表
    getLocationList: function () {
      this.formSearch.bizId = this.organ.bizId;
      this.formSearch.bizType = this.organ.bizType;
      this.formSearch.parentId = this.organ.orgId;
      this.$getJSON(apis.deviceLocationPage, this.formSearch).then((res) => {
        this.tableList = res.data.list || [];
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getLocationList();
    },
    // 关联设备
    bindDevice: function () {
      const params = this.tableSelect.map(t => ({
        orgId: this.orgId,
        bizId: this.organ.bizId,
        bizType: this.organ.bizType,
        toBizId: t.locationId,
        toBizType: 4,
      }));
      this.$postJSON(apis.organDeviceBindAutoAdd, params, true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success');
      });
    },
  },
};
</script>

<style lang="scss"></style>
